<template>
  <v-app style="background: #eee" class="pa-3">
	  <div>
		<span class="display-1 font-weight-light">My Profile</span>
		<v-divider class="mt-2" />
		
		<v-layout class="ma-3" row wrap>
			<v-card width="auto" class="profile pa-4 amber--text" color="#35455c">
				<v-layout justify-center row wrap>
					
					<v-card class="ma-3" style="border-radius: 10px" height="220" width="220">
						<v-img :src="avatar" height="220" contain/>
					</v-card>
					
					<v-card class="ma-3 amber--text" color="#00000000" flat>
						<span class="font-weight-light nametitle">{{ name }}</span>
						<v-divider class="mt-1 mb-3" dark/>
						<v-card class="pa-2 pl-3 amber--text" flat style="border-radius: 10px" color="rgba(0,0,0,0.2)">
						<span class="font-weight-light" style="font-size: 20px">Email</span>
						<br/>
						<span class="font-weight-light font-italic" style="font-size: 16px">{{ email }}</span>
						</v-card>
						<v-card class="pa-2 pl-3 mt-2 amber--text" flat style="border-radius: 10px" color="rgba(0,0,0,0.2)">
						<span class="font-weight-light" style="font-size: 20px">Contact</span>
						<br/>
						<span class="font-weight-light font-italic" style="font-size: 16px">+91 - {{ contact }}</span>
						</v-card>
					</v-card>
				</v-layout>
			</v-card>
		</v-layout>
	  </div>
	  <div class="pt-4">
		<span class="display-1 font-weight-light">Services</span>
		<v-divider class="mt-2" />
		<v-layout row wrap>
			<DashboardCon/>
		</v-layout>
	  </div>
  </v-app>
</template>

<script>
import DashboardCon from "@/components/DashboardCon.vue";
import firebase, { firestore } from 'firebase';
export default {
  components: {
	DashboardCon
  },

  data(){
	  return{
		  name: firebase.auth().currentUser.displayName,
		  avatar: firebase.auth().currentUser.photoURL,
		  email: firebase.auth().currentUser.email,
		  contact: null
	  }
  },
  created(){
	  	var vm = this;
		firebase.firestore().collection('users')
		.doc(firebase.auth().currentUser.uid)
		.get()
		.then(function(doc){
			vm.contact = doc.data().contact
		})
	}
};
</script>


<style scoped>
.profile{
	border-radius: 10px;
	width: 100%;
}

.nametitle{
	font-size: 28px;
}
</style>